import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SiteRoutes } from "./App";
import { I18nProvider } from "./i18n";
import "./styles.css";
import "./redesign.css";
import "./netbird-theme.css";
import "./components/subscription.css";
import "./account-console.css";
import "./legal.css";
import './invitations.css';

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Missing #root element");
}

const application = (
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <SiteRoutes />
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, application);
} else {
  createRoot(rootElement).render(application);
}
